import { BenefitType } from "../enums/BenefitType";
import { WellnessScreeningType } from "../enums/WellnessScreeningType";

export type WellnessFormValues = {
    screeningType: WellnessScreeningType,
}

export const defaultWellnessFormValues = {
    benefit: BenefitType.WELLNESS,
    wellness: true,
    screeningType: '',
}